import { SessionState } from './state';

export const mutations = {
  setFilters(state: SessionState, payload) {
    state.filtersMap[payload.name] = payload.value;
  },
  setFilterHash(state: SessionState, payload) {
    state.filterHashMap[payload.name] = payload.value;
  },
  setAdvancedSearchVisible(state: SessionState, payload) {
    state.advancedSearchVisibleMap[payload.name] = payload.value;
  },
  setTableOptions(state: SessionState, payload) {
    state.tableOptionsMap[payload.name] = payload.value;
  },
  setCachedChoice(state: SessionState, payload) {
    state.choiceCache[payload.name] = payload.value;
  }
};
